export const XRAY_WELCOME_MESSAGE =
  "Explore nosso abrangente Painel de Análise da Operação. Esta ferramenta foi projetada para ajudá-lo a tomar decisões e otimizar suas operações de forma eficaz. Mergulhe e obtenha uma visão única do seu cenário operacional!";
export const DELIVERY_CENTER_WELCOME_MESSAGE =
  "Esse é o Painel de Configurações da sua operação! Organizado da melhor maneira para que você tenha controle de tudo o que acontece por aí";
